export default "__VITE_ASSET__Ct38Epua__"